import i18n, { Resource } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import checkout_en from "@/embeddedCheckout/locales/en/checkout.json";
import checkout_xx from "@/embeddedCheckout/locales/xx/checkout.json";
import common_en from "./en/common.json";
import common_es from "./es/common.json";
import common_fr from "./fr/common.json";
import common_xx from "./xx/common.json";
import settings_en from "./en/settingsPage.json";
import settings_es from "./es/settingsPage.json";
import settings_fr from "./fr/settingsPage.json";
import settings_xx from "./xx/settingsPage.json";
import dashboard_en from "./en/dashboard.json";
import dashboard_es from "./es/dashboard.json";
import dashboard_fr from "./fr/dashboard.json";
import dashboard_xx from "./xx/dashboard.json";
import routine_en from "./en/routine.json";
import routine_es from "./es/routine.json";
import routine_fr from "./fr/routine.json";
import routine_xx from "./xx/routine.json";
import contacts_en from "./en/contacts.json";
import contacts_es from "./es/contacts.json";
import contacts_fr from "./fr/contacts.json";
import contacts_xx from "./xx/contacts.json";
import apps_en from "./en/apps.json";
import apps_es from "./es/apps.json";
import apps_fr from "./fr/apps.json";
import apps_xx from "./xx/apps.json";
import schedule_en from "./en/schedule.json";
import schedule_es from "./es/schedule.json";
import schedule_fr from "./fr/schedule.json";
import schedule_xx from "./xx/schedule.json";
import onBoarding_en from "./en/onBoarding.json";
import onBoarding_es from "./es/onBoarding.json";
import onBoarding_fr from "./fr/onBoarding.json";
import onBoarding_xx from "./xx/onBoarding.json";
import auth_en from "./en/auth.json";
import auth_es from "./es/auth.json";
import auth_fr from "./fr/auth.json";
import auth_xx from "./xx/auth.json";
import conversations_en from "./en/conversations.json";
import conversations_es from "./es/conversations.json";
import conversations_fr from "./fr/conversations.json";
import conversations_xx from "./xx/conversations.json";
import validations_en from "./en/validations.json";
import validations_es from "./es/validations.json";
import validations_fr from "./fr/validations.json";
import validations_xx from "./xx/validations.json";
import deviceAuth_en from "./en/deviceAuth.json";
import deviceAuth_es from "./es/deviceAuth.json";
import deviceAuth_fr from "./fr/deviceAuth.json";
import deviceAuth_xx from "./xx/deviceAuth.json";
import pinwheelAsk_en from "./en/pinwheelAsk.json";
import pinwheelAsk_es from "./es/pinwheelAsk.json";
import pinwheelAsk_fr from "./fr/pinwheelAsk.json";
import pinwheelAsk_xx from "./xx/pinwheelAsk.json";
import embeddedGpt_en from "@/embeddedGpt/locales/en/embeddedGpt.json";
import embeddedGpt_es from "@/embeddedGpt/locales/es/embeddedGpt.json";
import embeddedGpt_fr from "@/embeddedGpt/locales/fr/embeddedGpt.json";
import embeddedGpt_xx from "@/embeddedGpt/locales/xx/embeddedGpt.json";
import billing_en from "./en/billing.json";
import billing_es from "./es/billing.json";
import billing_fr from "./fr/billing.json";
import billing_xx from "./xx/billing.json";
import notifications_en from "./en/notifications.json";
import notifications_es from "./es/notifications.json";
import notifications_fr from "./fr/notifications.json";
import notifications_xx from "./xx/notifications.json";
import feedback_en from "./en/feedback.json";
import feedback_es from "./es/feedback.json";
import feedback_fr from "./fr/feedback.json";
import feedback_xx from "./xx/feedback.json";
import cellular_en from "./en/cellular.json";
import cellular_es from "./es/cellular.json";
import cellular_fr from "./fr/cellular.json";
import cellular_xx from "./xx/cellular.json";
import rare_en from "./en/rare.json";
import rare_es from "./es/rare.json";
import rare_fr from "./fr/rare.json";
import rare_xx from "./xx/rare.json";

export const defaultNS = "common";
export const resources: Resource = {
  en: {
    common: common_en,
    checkout: checkout_en,
    settings: settings_en,
    rare: rare_en,
    dashboard: dashboard_en,
    routine: routine_en,
    contacts: contacts_en,
    apps: apps_en,
    schedule: schedule_en,
    onBoarding: onBoarding_en,
    auth: auth_en,
    conversations: conversations_en,
    validations: validations_en,
    deviceAuth: deviceAuth_en,
    pinwheelAsk: pinwheelAsk_en,
    embeddedGpt: embeddedGpt_en,
    billing: billing_en,
    notifications: notifications_en,
    feedback: feedback_en,
    cellular: cellular_en,
  },
  es: {
    common: common_es,
    settings: settings_es,
    rare: rare_es,
    dashboard: dashboard_es,
    routine: routine_es,
    contacts: contacts_es,
    apps: apps_es,
    schedule: schedule_es,
    onBoarding: onBoarding_es,
    auth: auth_es,
    conversations: conversations_es,
    validations: validations_es,
    deviceAuth: deviceAuth_es,
    pinwheelAsk: pinwheelAsk_es,
    embeddedGpt: embeddedGpt_es,
    billing: billing_es,
    notifications: notifications_es,
    feedback: feedback_es,
    cellular: cellular_es,
  },
  fr: {
    common: common_fr,
    settings: settings_fr,
    rare: rare_fr,
    dashboard: dashboard_fr,
    routine: routine_fr,
    contacts: contacts_fr,
    apps: apps_fr,
    schedule: schedule_fr,
    onBoarding: onBoarding_fr,
    auth: auth_fr,
    conversations: conversations_fr,
    validations: validations_fr,
    deviceAuth: deviceAuth_fr,
    pinwheelAsk: pinwheelAsk_fr,
    embeddedGpt: embeddedGpt_fr,
    billing: billing_fr,
    notifications: notifications_fr,
    feedback: feedback_fr,
    cellular: cellular_fr,
  },
  xx: {
    common: common_xx,
    checkout: checkout_xx,
    settings: settings_xx,
    rare: rare_xx,
    dashboard: dashboard_xx,
    routine: routine_xx,
    contacts: contacts_xx,
    apps: apps_xx,
    schedule: schedule_xx,
    onBoarding: onBoarding_xx,
    auth: auth_xx,
    conversations: conversations_xx,
    validations: validations_xx,
    deviceAuth: deviceAuth_xx,
    pinwheelAsk: pinwheelAsk_xx,
    embeddedGpt: embeddedGpt_xx,
    billing: billing_xx,
    notifications: notifications_xx,
    feedback: feedback_xx,
    cellular: cellular_xx,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    ns: [
      defaultNS,
      "checkout",
      "common",
      "settings",
      "dashboard",
      "routine",
      "contacts",
      "apps",
      "schedule",
      "onBoarding",
      "auth",
      "conversations",
      "validations",
      "deviceAuth",
      "pinwheelAsk",
      "embeddedGpt",
      "billing",
      "notifications",
      "feedback",
      "cellular",
      "rare",
    ],
    defaultNS: defaultNS,
    supportedLngs: ["en", "es", "fr", "xx"],
    interpolation: {
      escapeValue: false,
    },
    resources: resources,
    // lng: "en",
  });

export default i18n;
